module.exports = "<span class=\"label label-{{ data?.classes }}\">{{ data?.value }}</span>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-datatable/src/components/values/label/label.component.html
// module id = ./libs/chassis-datatable/src/components/values/label/label.component.html
// module chunks = main